export default function GrainOverlay() {
  return <div className="grain" aria-hidden="true" data-testid="grain-overlay" />;
}
